export const capitalizeFirstLetter = (value: string) => {
    const sanitized = sanitizeString(value)

    return sanitized.charAt(0).toUpperCase() + sanitized.slice(1)
}

export const sanitizeString = (value: string) => {
    return value.replace(/^\s+/, '').replaceAll(/ {2,}/g, ' ')
}
